export default __webpack_public_path__ + "static/4-cea7c9751d788d77aa8344fe3e8cea5e.png";